export default __webpack_public_path__ + "static/media/mobile_cardcustom.0e6d5a73.webp";